import Center from "../../assets/images/product/facadeEco/center.webp";
import Left from "../../assets/images/product/facadeEco/left.webp";
import FacadeEco from "../../assets/images/products/facadeEco.webp";
import { categoriesOfPaints } from "../categoryOfPaints";

export const facadeEco = {
  category: [categoriesOfPaints.facade],
  path: "festek_facade_eco",
  name: "FESTEK-FAСADE ECO",
  header: "Краска фасадная акриловая «FESTEK-FAСADE ECO»",
  link: "https://drive.google.com/file/d/1m_hclzr0Dy5zwSIJOnToax4tsLl8aerZ/view?usp=sharing",
  purchase: [
    {
      price: "90,00",
      amount: "15 кг",
    },
  ],
  productsPage: {
    title: "Фасадная «FESTEK-FAСADE ECO»",
    text: "Укрывистая, атмосферостойкая краска с сопротивлением влиянию УФ лучей",
  },
  images: {
    products: FacadeEco,
    product: [Center, Left],
  },
  documentation: {
    description: {
      concept: {
        value:
          "это фасадная акриловая краска для наружной отделки зданий и сооружений. Обладает хорошей укрывистостью и адгезией к основанию.",
        label: "FESTEK «FAСADE ECO»",
      },

      properties: {
        value: [
          "Образует долговечное покрытие.",
          "Высокая адгезия к основанию и укрывистость.",
          "Стойкое к воздействию климатических факторов.",
          "Обладает высокой светостойкостью.",
          "Образованное покрытие устойчиво к разрушающему воздействию атмосферных осадков, перепадов температур.",
          "Имеет насыщенный белый оттенок.",
        ],
        label: "Преимущество",
        note: [
          "*Прогнозируемый срок службы покрытия при соблюдении технологии нанесения в комплексе с грунтовками – не менее 5 лет.",
        ],
      },

      consumption: {
        value:
          "На двухслойное покрытие – 350 - 400 г/м2. Зависит от пористости поверхности, применяемого оборудования, квалификации персонала, погодных условий. При окрашивании фактурных поверхностей (типа: шуба, барашек, короед и т.п.) расход краски увеличивается в 1,5 раза.",
        label: "Расход",
      },

      package: {
        value: "11 литров – 15 килограмм; 20 литров – 25 килограмм.",
        label: "Упаковка",
      },

      suitableSubstrates: {
        value:
          "Бетонные, кирпичные, оштукатуренные, гипсокартонные и другие минеральные поверхности, печи, откосы, железобетонные заборы.",
        label: "Пригодные подложки",
      },

      coatingSystem: {
        value:
          "Для получения качественного покрытия и снижения расхода краски поверхность обработать грунтовкой «Festek-Grunt» для глубокого проникновения или «Festek-MaxiGrunt», исходя из рекомендаций по применению. Краска готова к применению. При необходимости допускается разбавление водой – не более 5 %, при безвоздушном нанесении - около 10 %",
        label: "Система покрытия",
      },

      colorSolutions: {
        value:
          "Белый + цвета по большинству колеровочных системы. Возможен подбор цвета по вашему образцу. Богатую палитру цветов можете выбрать у нас сайте",
        label: "Цветовые решения",
      },
    },

    applicationTechnology: {
      composition: {
        value:
          "Суспензия пигментов и наполнителей в водной дисперсии акрилового сополимера с добавлением вспомогательных веществ.",
        label: "Состав",
      },

      preparationSurfaces: {
        value:
          "Новые бетонные основания следует окрашивать не ранее, чем через 28 дней после их естественного высыхания, оштукатуренные полимерминеральными составами – не ранее, чем через 8 дней после их естественного высыхания. После дождя поверхность должна просохнуть в течение 2 - 3 дней.",
        label: "Подготовка поверхности",
      },

      methodAndConditionsDrawing: {
        value: `Работы проводить при температуре окружающего воздуха, краски и окрашиваемой поверхности от 10 °С до 25 °С. Не допускается нанесение при неблагоприятных погодных условиях (дождь, туман, выпадение росы). При проведении окрасочных работ влажность основания должна быть не более 8 %, влажность воздуха в помещении – 40 - 60 %, при фасадных работах – не более 80 %. Краска готова к применению. При необходимости допускается разбавление водой – не более 5 %, при безвоздушном нанесении - около 10 %. Упаковку с частично использованным материалом тщательно закрыть, а ее содержимое использовать в наиболее короткий срок. Перед применением краску тщательно перемешать и наносить на поверхность: •\u00A0Кистью •\u00A0Валиком •\u00A0Пневматическим или безвоздушным методом распыления. После работы инструмент, пятна отмыть теплой водой с мылом до высыхания краски. Краска одного цвета, но различных партий, может незначительно отличаться по тону. Для исключения разнооттеночности получаемого покрытия следует выбирать краску одной партии, смешивать необходимое количество материала различных партий в отдельной емкости, либо окрашивать участки поверхностей, не лежащие в одной зрительной плоскости.`,
        label: "Способ и условия нанесения",
      },

      temperature: {
        value:
          "Промежуточная сушка между слоями - 4 часа при температуре (20 ± 2) °С. При более низкой температуре, высокой влажности продолжительность сушки может увеличиваться до 24 ч.",
        label: "Температурный режим, время высыхания",
      },

      endlessApplication: {
        value:
          'При нанесении краскопультом (безвоздушное) рекомендуются след. параметры: угол распыления 60°, диаметр сопла 0,53-0,58 мм (0,021"-0,023" дюйма), Давление 175-180 bar.',
        label: "Безвоздушное нанесение",
      },
    },

    technicalData: [
      {
        qualityIndicators: "Массовая доля нелетучих веществ, %",
        value: "60 - 68",
      },
      {
        qualityIndicators: "Показатель концентрации ионов водорода, рН",
        value: "7,5 - 9,5",
      },
      { qualityIndicators: "Степень перетира, мкм, не более", value: "70" },
      {
        qualityIndicators:
          "Время высыхания до степени 3 при температуре (20 ± 2) °С, ч, не более",
        value: "1",
      },
      {
        qualityIndicators:
          "Условная светостойкость покрытия за 24 ч (изменение коэффициента диффузного отражения), %, не более",
        value: "5",
      },
      {
        qualityIndicators: "Адгезия покрытия к основанию, МПа, не менее",
        value: "1,5",
      },
      {
        qualityIndicators:
          "Стойкость покрытия к статическому воздействию воды при температуре (20 ± 2) °С, ч, не менее",
        value: "24",
      },
      {
        qualityIndicators:
          "Коэффициент паропроницаемости, мг/(м ч Па), не менее",
        value: "0,015",
      },
      {
        qualityIndicators: "Морозостойкость покрытия, циклы, не менее",
        value: "50",
      },
      {
        qualityIndicators:
          "Стойкость покрытия к воздействию климатических факторов, циклы, не менее",
        value: "100",
      },
      {
        qualityIndicators:
          "Срок службы покрытия в условиях эксплуатации У1, лет, не менее",
        value: "5",
      },
    ],
  },
};
